import classes from "./FourStep.module.scss"
import body from "../../../index.module.scss"
import ColoredBlock from './../../ColoredBlock/ColoredBlock';
import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import Cards from './../../Cards/Cards';

const FourStep = () => {
    return(
        <section className={classes.Nuanses} id="Nuances" >
            <div className={body.container}>
                <ColoredBlock number={4} customClass={classes.ColoredBlock} CustomNumClass={classes.CustomNumClass}/>
                <SectionTitle text={<>Нюансы<br/> проекта</>} customClass={classes.Title}/>
                <div className={classes.CardsList}>
                <Cards
                    customClass={classes.Item}
                    customTitleClass={classes.CardsTitle}
                    number={"01."}
                    title={<>До нас над сайтом работало большое  количество студий, как по технической поддержке сайта, так и по SEO. Поддержка как старого, так и нового сайта, с незнакомым нам кодом никак не отразилась на сроках внесения правок.</>}
                />
                <Cards
                    customClass={classes.Item}
                    customTitleClass={classes.CardsTitle}
                    number={"02."}
                    title={<>Что касается работ по SEO, то все работы, произведенные сторонними специалистами были сделаны заново на 100%.</>}
                />
                <Cards
                    customClass={classes.Item}
                    customTitleClass={classes.CardsTitle}
                    number={"03."}
                    title={<>Кроме этого стоит упомянуть, что наш Заказчик – это крупная компания, в которой есть сложности с обсуждением и утверждением всех предложений и решений. Этот факт также затруднял работы как по SEO, так и по поддержке.</>}
                />
                </div>
            </div>
        </section>
    )
}
export default FourStep;